import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row mb-2" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "row mt-2" }
const _hoisted_4 = {
  for: "name",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_5 = { class: "col-sm-8" }
const _hoisted_6 = { class: "row mt-2" }
const _hoisted_7 = {
  for: "email",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_8 = { class: "col-sm-8" }
const _hoisted_9 = ["readonly"]
const _hoisted_10 = { class: "row mt-2" }
const _hoisted_11 = {
  for: "is_blocked",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_12 = { class: "col-sm-8" }
const _hoisted_13 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_14 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_15 = {
  for: "createInvite",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_16 = { class: "col-sm-8" }
const _hoisted_17 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_18 = {
  key: 1,
  class: "row mt-2"
}
const _hoisted_19 = {
  for: "password",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_20 = { class: "col-sm-8" }
const _hoisted_21 = {
  key: 2,
  class: "row mt-2"
}
const _hoisted_22 = {
  for: "traderId",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_23 = { class: "col-sm-8" }
const _hoisted_24 = {
  key: 3,
  class: "row mt-2"
}
const _hoisted_25 = {
  for: "2fa",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_26 = { class: "col-sm-8 align-items-center d-flex" }
const _hoisted_27 = {
  key: 0,
  class: "text-success"
}
const _hoisted_28 = {
  key: 1,
  class: "text-warning"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!

  return (_openBlock(), _createElementBlock("form", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.helper.trans("labels.name")), 1),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_FormInputWrapper, {
              errors: _ctx.getErrors(`name`)
            }, {
              default: _withCtx((parentProps) => [
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass([parentProps.class, "form-control"]),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
                  type: "text",
                  id: "name"
                }, null, 2), [
                  [_vModelText, _ctx.form.name]
                ])
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.helper.trans("labels.email")), 1),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_FormInputWrapper, {
              errors: _ctx.getErrors(`email`)
            }, {
              default: _withCtx((parentProps) => [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.email) = $event)),
                  class: _normalizeClass([parentProps.class, "form-control"]),
                  readonly: !!_ctx.form.id,
                  type: "text",
                  id: "email"
                }, null, 10, _hoisted_9), [
                  [_vModelText, _ctx.form.email]
                ])
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.helper.trans("labels.is_blocked")), 1),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.isBlocked) = $event)),
                class: "form-check-input",
                type: "checkbox",
                id: "is_blocked"
              }, null, 512), [
                [_vModelCheckbox, _ctx.form.isBlocked]
              ])
            ])
          ])
        ]),
        (!_ctx.form.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.helper.trans("labels.create_invite")), 1),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.createInvite) = $event)),
                    class: "form-check-input",
                    type: "checkbox",
                    id: "createInvite"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.form.createInvite]
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        ((_ctx.form.id || _ctx.form.createInvite === false) && (_ctx.isTrader || _ctx.store.getters.hasPermission(_ctx.UserPermission.RESET_TRADER_PASSWORD)))
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.helper.trans("labels.password")), 1),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_FormInputWrapper, {
                  errors: _ctx.getErrors(`password`)
                }, {
                  default: _withCtx((parentProps) => [
                    _createElementVNode("div", {
                      class: _normalizeClass(["input-group", parentProps.class])
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.password) = $event)),
                        class: _normalizeClass([parentProps.class, "form-control"]),
                        type: "text",
                        id: "password"
                      }, null, 2), [
                        [_vModelText, _ctx.form.password]
                      ]),
                      _createElementVNode("button", {
                        onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.form.password = _ctx.helper.generatePassword()), ["prevent"])),
                        type: "button",
                        class: "btn btn-outline-secondary"
                      }, _cache[8] || (_cache[8] = [
                        _createElementVNode("i", { class: "fa fa-rotate" }, null, -1)
                      ]))
                    ], 2)
                  ]),
                  _: 1
                }, 8, ["errors"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isAdmin)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.helper.trans("labels.trader")), 1),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_FormInputWrapper, {
                  errors: _ctx.getErrors(`traderId`)
                }, {
                  default: _withCtx((parentProps) => [
                    _createVNode(_component_Multiselect, {
                      id: "traderId",
                      class: _normalizeClass(["", parentProps.class]),
                      modelValue: _ctx.form.trader,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.trader) = $event)),
                      "track-by": "id",
                      disabled: !!_ctx.form.id,
                      options: _ctx.traders,
                      "custom-label": (opt) => `${opt.name} (${opt.email})`,
                      "custom-value": (opt) => opt.id,
                      "select-label": "Select",
                      placeholder: "",
                      "open-direction": "bottom",
                      multiple: false,
                      searchable: true,
                      "internal-search": true,
                      "clear-on-select": false,
                      "close-on-select": true,
                      "options-limit": 100,
                      limit: 1000,
                      "show-no-results": false,
                      "hide-selected": false,
                      onSearchChange: _ctx.asyncFindTraders,
                      loading: _ctx.isTradersSelectLoading
                    }, null, 8, ["class", "modelValue", "disabled", "options", "custom-label", "custom-value", "onSearchChange", "loading"])
                  ]),
                  _: 1
                }, 8, ["errors"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.form.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.helper.trans("labels.2fa")), 1),
              _createElementVNode("div", _hoisted_26, [
                (_ctx.form?.is2faEnabled)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.helper.trans('labels.enabled')), 1))
                  : _createCommentVNode("", true),
                (!_ctx.form?.is2faEnabled)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                      _cache[9] || (_cache[9] = _createElementVNode("i", { class: "fa fa-warning" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('labels.disabled')), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.form?.is2faEnabled)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      type: "button",
                      class: "btn btn-danger ms-2 btn-sm text-capitalize-first",
                      onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.disable2fa(_ctx.form.id)), ["prevent"]))
                    }, _toDisplayString(_ctx.helper.trans("labels.disable")), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_ConfirmModal, { ref: "twoFaConfirmModal" }, null, 512)
  ]))
}